<template>
  <div id="modalCreateEditOrcamento" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Período</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Ano do Orçamento: <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.orcamento.ano.$errors.length,
                  }"
                  min="1"
                  step="1"
                  placeholder="Ano do Orçamento"
                  v-model="v$.orcamento.ano.$model"
                />
                <span
                  v-if="v$.orcamento.ano.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Data de Início da Proposta: <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.orcamento.dataInicialProposta.$errors.length,
                  }"
                  v-model="v$.orcamento.dataInicialProposta.$model"
                />
                <span
                  v-if="v$.orcamento.dataInicialProposta.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="
                    v$.orcamento.dataInicialProposta.lessThanDataFinalProposta
                      .$invalid
                  "
                  class="invalid-feedback"
                >
                  A data de início tem que ser menor que a data de término
                  (proposta)
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Data de Término da Proposta:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.orcamento.dataFinalProposta.$errors.length,
                  }"
                  v-model="v$.orcamento.dataFinalProposta.$model"
                />
                <span
                  v-if="v$.orcamento.dataFinalProposta.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="
                    v$.orcamento.dataFinalProposta
                      .greaterThanDataInicialProposta.$invalid
                  "
                  class="invalid-feedback"
                >
                  A data de término tem que ser maior que a data de início
                  (proposta)
                </span>
                <span
                  v-if="
                    v$.orcamento.dataFinalProposta
                      .lessThanDataInicialReformulacao.$invalid
                  "
                  class="invalid-feedback"
                >
                  A data de término tem que ser menor que a data de início
                  (reformulação)
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Data de Início da Reformulação:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.orcamento.dataInicialReformulacao.$errors.length,
                  }"
                  v-model="v$.orcamento.dataInicialReformulacao.$model"
                />
                <span
                  v-if="v$.orcamento.dataInicialReformulacao.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="
                    v$.orcamento.dataInicialReformulacao
                      .greaterThanDataFinalProposta.$invalid
                  "
                  class="invalid-feedback"
                >
                  A data de início tem que ser maior que a data de término
                  (proposta)
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Data de Término da Reformulação:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.orcamento.dataFinalReformulacao.$errors.length,
                  }"
                  v-model="v$.orcamento.dataFinalReformulacao.$model"
                />
                <span
                  v-if="v$.orcamento.dataFinalReformulacao.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="
                    v$.orcamento.dataFinalReformulacao
                      .greaterThanDataInicialReformulacao.$invalid
                  "
                  class="invalid-feedback"
                >
                  A data de término tem que ser maior que a data de início
                  (reformulação)
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-success"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditOrcamentoModal',

  props: {
    orcamentoId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      orcamento: {
        id: '',
        ano: '',
        dataInicialProposta: '',
        dataFinalProposta: '',
        dataInicialReformulacao: '',
        dataFinalReformulacao: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.orcamentoId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getOrcamento() {
      try {
        this.orcamento = await this.$store.dispatch(
          'getOrcamento',
          this.orcamentoId,
        )
        showModal('modalCreateEditOrcamento')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.orcamentoId) {
            response = await this.$store.dispatch(
              'updateOrcamento',
              this.orcamento,
            )
          } else {
            response = await this.$store.dispatch(
              'saveOrcamento',
              this.orcamento,
            )
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      orcamento: {
        ano: {
          required,
        },
        dataInicialProposta: {
          required,
          lessThanDataFinalProposta: (value) => {
            return (
              !this.orcamento.dataFinalProposta ||
              value < this.orcamento.dataFinalProposta
            )
          },
        },
        dataFinalProposta: {
          required,
          greaterThanDataInicialProposta: (value) => {
            return (
              !this.orcamento.dataInicialProposta ||
              value > this.orcamento.dataInicialProposta
            )
          },
          lessThanDataInicialReformulacao: (value) => {
            return (
              !this.orcamento.dataInicialReformulacao ||
              value < this.orcamento.dataInicialReformulacao
            )
          },
        },
        dataInicialReformulacao: {
          required,
          greaterThanDataFinalProposta: (value) => {
            return (
              !this.orcamento.dataFinalProposta ||
              value > this.orcamento.dataFinalProposta
            )
          },
          lessThanDataFinalReformulacao: (value) => {
            return (
              !this.orcamento.dataFinalReformulacao ||
              value < this.orcamento.dataFinalReformulacao
            )
          },
        },
        dataFinalReformulacao: {
          required,
          greaterThanDataInicialReformulacao: (value) => {
            return (
              !this.orcamento.dataInicialReformulacao ||
              value > this.orcamento.dataInicialReformulacao
            )
          },
        },
      },
    }
  },

  mounted() {
    if (this.orcamentoId) {
      this.getOrcamento()
    } else {
      showModal('modalCreateEditOrcamento')
    }
  },
}
</script>
